module.exports = __webpack_public_path__ + "img/dialog-error.0d878a1c.svg";